import IInlineVideo from '@models/IInlineVideo';
import { ILightBoxImage } from '@models/ILightBoxImage';
import ImageLightBox from '@molecules/ImageLightBox/ImageLightBox';
import InViewVideo from '@molecules/InViewVideo/InViewVideo';

interface Props {
  readonly image?: ILightBoxImage;
  readonly video?: IInlineVideo;
  readonly title: string;
}

const CampaignHero = ({ image, video, title = '' }: Props) => (
  <section
    className="component-padding bg-white text-black-100 dark:bg-black-100 dark:text-white"
    data-testid="CT-04B-Campaign-Hero"
  >
    <div className="container">
      {title && (
        <div className="grid xl:grid-cols-12">
          <div
            className="yellow-highlight h1 col-span-10 pb-7 xl:col-start-2 xl:col-end-8 xl:pb-24"
            dangerouslySetInnerHTML={{ __html: title }}
            data-testid="CT-04B-Campaign-Hero-Title"
          />
        </div>
      )}

      {video?.video?.url && (
        <InViewVideo dataTestId="CT-04B-Campaign-Hero-Video" {...video} />
      )}

      {!video?.video?.url && image?.image && (
        <ImageLightBox
          dataTestId="CT-04B-Campaign-Hero-Image"
          {...image}
          imageClasses="h-full w-full"
          contentIds={
            image.meta?.contentLink ? [image.meta.contentLink as string] : []
          }
        />
      )}
    </div>
  </section>
);

export default CampaignHero;
